<template>
  <a
    :class="classes"
    :href="phoneNumberTel"
    @click="gtmPhoneCallTrigger($event, gtmLabel)"
    v-text="phoneNumber"
  />
</template>

<script>
import { usePhoneNumber } from 'Main/composables/usePhoneNumber';

export default {
  name: 'PhoneNumberLink',

  setup() {
    const {
      phoneNumber,
      phoneNumberTel,
      hidePhoneNumber,
      isTherapyPage,
      countryPhoneCode,
      maybeUpdatePhoneNumber,
      updatePhoneNumber,
      ctmRunNow,
      ctmInit,
      gtmPhoneCallTrigger,
    } = usePhoneNumber();
    return {
      phoneNumber,
      phoneNumberTel,
      hidePhoneNumber,
      isTherapyPage,
      countryPhoneCode,
      maybeUpdatePhoneNumber,
      updatePhoneNumber,
      ctmRunNow,
      ctmInit,
      gtmPhoneCallTrigger,
    };
  },

  data() {
    const { classes, gtmLabel, overrideHiddenNumber } = this.$mountEl.dataset;
    return {
      classes: classes || '',
      gtmLabel: gtmLabel || '',
      overrideHiddenNumber: overrideHiddenNumber === 'true',
    };
  },

  mounted() {
    if (this.hidePhoneNumber && !this.overrideHiddenNumber) {
      this.updatePhoneNumber(null);
    } else if (!this.isTherapyPage) {
      window.addEventListener(
        'city-storage-updated-event',
        this.maybeUpdatePhoneNumber
      );
      this.maybeUpdatePhoneNumber();
    }

    setTimeout(() => {
      this.$el.classList.add('is-visible');
    }, 100);
  },

  beforeUnmount() {
    window.removeEventListener(
      'city-storage-updated-event',
      this.maybeUpdatePhoneNumber
    );
  },
};
</script>
